import type { SegmentSnapshot } from "./arrangementStore";
import { useInstrumentStore } from "./instrumentStore";

export function snapshotEditorState(): SegmentSnapshot {
  const s = useInstrumentStore.getState();
  return {
    bpm: s.bpm,
    pattern: s.pattern,
    melodyGrids: s.melodyGrids,
    fx: s.fx,
    trackMutes: s.trackMutes,
    drumMutes: s.drumMutes,
    subdivisions: s.subdivisions,
    rootPitch: s.rootPitch,
    blueFlat3: s.blueFlat3,
    blueFlat5: s.blueFlat5,
  };
}
